import * as RadixRadioGroup from '@radix-ui/react-radio-group';

import { cn } from '~/lib/cn';
import { CampaignTypeRadioButton } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/components/PlanWizard/components/CampaignTypeSection/components/CampaignTypeRadioButton';
import type { CampaignType } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/constants';

export interface CampaignTypeRadioButtonGroupProps {
  types: CampaignType[];
  value?: CampaignType;
  className?: string;
  onSelect?: (value: CampaignType) => void;
}

export function CampaignTypeRadioButtonGroup({
  types,
  value,
  className = '',
  onSelect,
}: CampaignTypeRadioButtonGroupProps) {
  return (
    <RadixRadioGroup.Root
      className={cn('flex flex-row flex-wrap gap-lg', className)}
      value={value}
      onValueChange={onSelect}
    >
      {types.map((type) => {
        return (
          <CampaignTypeRadioButton
            key={type}
            campaignType={type}
            isSelected={type === value}
          />
        );
      })}
    </RadixRadioGroup.Root>
  );
}

CampaignTypeRadioButtonGroup.displayName = 'CampaignTypeRadioButtonGroup';
